/**
 * 路由表 —— 4 Tab 主界面 + 认证全屏流程。
 *
 * 「发现」Tab 本期推迟：**路由 `/discover` 存在，入口隐藏**（ARCH D-2）。
 * 锁屏守卫由 `App.tsx` 统一处理（未创建 → /welcome；已锁定 → /unlock）。
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import type { ReactElement } from 'react';

import { Onboarding } from '@/features/auth/Onboarding';
import { WelcomePage } from '@/features/auth/WelcomePage';
import { CreateIdentityPage } from '@/features/auth/CreateIdentityPage';
import { BackupPage } from '@/features/auth/BackupPage';
import { UnlockPage } from '@/features/auth/UnlockPage';
import { ImportPage } from '@/features/auth/ImportPage';
import { ChatListPage } from '@/features/chat/ChatListPage';
import { FeedPage } from '@/features/feed/FeedPage';
import { DiscoverPage } from '@/features/discover/DiscoverPage';
import { MePage } from '@/features/me/MePage';
import { SecurityPage } from '@/features/me/SecurityPage';
import { WalletPage } from '@/features/wallet/WalletPage';
import { SettingsPage } from '@/features/settings/SettingsPage';
import { DexPage } from '@/features/dex/DexPage';
import { RewardsPage } from '@/features/rewards/RewardsPage';

export const ROUTE_PATH = {
  onboarding: '/onboarding',
  welcome: '/welcome',
  create: '/create',
  backup: '/backup',
  import: '/import',
  unlock: '/unlock',
  chat: '/chat',
  feed: '/feed',
  discover: '/discover',
  me: '/me',
  security: '/me/security',
  wallet: '/wallet',
  settings: '/settings',
  /** 交易大厅：/dex 被 DP 链管理台 Basic Auth 占用（nginx 精确匹配），改用 /trade */
  dex: '/trade',
  rewards: '/rewards',
} as const;

export function AppRoutes(): ReactElement {
  return (
    <Routes>
      {/* —— 认证全屏流程 —— */}
      <Route path={ROUTE_PATH.onboarding} element={<Onboarding />} />
      <Route path={ROUTE_PATH.welcome} element={<WelcomePage />} />
      <Route path={ROUTE_PATH.create} element={<CreateIdentityPage />} />
      <Route path={ROUTE_PATH.backup} element={<BackupPage />} />
      <Route path={ROUTE_PATH.import} element={<ImportPage />} />
      <Route path={ROUTE_PATH.unlock} element={<UnlockPage />} />

      {/* —— 主界面（4 Tab） —— */}
      <Route path={ROUTE_PATH.chat} element={<ChatListPage />} />
      <Route path={ROUTE_PATH.feed} element={<FeedPage />} />
      <Route path={ROUTE_PATH.discover} element={<DiscoverPage />} />
      <Route path={ROUTE_PATH.me} element={<MePage />} />
      <Route path={ROUTE_PATH.security} element={<SecurityPage />} />
      <Route path={ROUTE_PATH.wallet} element={<WalletPage />} />
      <Route path={ROUTE_PATH.settings} element={<SettingsPage />} />
      <Route path={ROUTE_PATH.dex} element={<DexPage />} />
      <Route path={ROUTE_PATH.rewards} element={<RewardsPage />} />

      <Route path="/" element={<Navigate to={ROUTE_PATH.chat} replace />} />
      <Route path="*" element={<Navigate to={ROUTE_PATH.chat} replace />} />
    </Routes>
  );
}

export default AppRoutes;
